<script lang="ts">
import { defineComponent, computed } from 'vue';
import { oneOfType } from 'vue-types';

import useConfig from '@/providers/config/useConfig';

export default defineComponent({
  name: 'HarmonLogoIcon',
  props: {
    width: oneOfType([String, Number]).def('100%'),
    height: oneOfType([String, Number]).def('100%'),
  },
  setup() {
    const light = {
      text: '#4D4D4D',
      sqTop: '#000000',
      sqLeft: '#808080',
      sqRight: '#E6E6E6',
      sqBottom: '#CCCCCC',
    };
    const dark = {
      text: '#FFFFFF',
      sqTop: '#FFFFFF',
      sqLeft: '#E6E6E6',
      sqRight: '#808080',
      sqBottom: '#CCCCCC',
    };
    const config = useConfig();
    return {
      colors: computed(() => (config.config.name === 'light' ? light : dark)),
      config,
    };
  },
});
</script>
<template>
  <!-- eslint-disable max-len -->
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 145 145"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path :fill="colors.sqTop" opacity="0.2" d="M72.0624 5.47767e-05L36 36.0625L72.0624 72.1249L108.125 36.0625L72.0624 5.47767e-05Z" />
    <path :fill="colors.sqLeft" opacity="0.2" d="M108.054 36.0001L71.9912 72.0625L108.054 108.125L144.116 72.0625L108.054 36.0001Z" />
    <path :fill="colors.sqRight" opacity="0.2" d="M36.0624 36.0015L0 72.064L36.0624 108.126L72.1249 72.064L36.0624 36.0015Z" />
    <path :fill="colors.sqBottom" opacity="0.2" d="M72.0537 72.0015L35.9912 108.064L72.0537 144.126L108.116 108.064L72.0537 72.0015Z" />
    <path :fill="colors.text" d="M44.1182 112.678V31.7124H46.6413V70.9335H98.2002V31.7124H100.723V112.678H98.2002V73.4567H46.6413V112.678H44.1182Z" />
  </svg>
</template>
